import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { EllipsisText } from '@vk-hr-tek/ui/EllipsisText';

interface NotificationItemHeaderProps {
  variant: 'list' | 'plugin';
  name: string;
  action: string;
  createdAt: string;
}

export const NotificationItemHeader = ({
  variant,
  name,
  action,
  createdAt,
}: NotificationItemHeaderProps) => {
  const isPlugin = variant === 'plugin';

  return (
    <Box display="flex" justifyContent="space-between" gap="8" width="100%">
      <Box display="flex" alignItems="center" gap="8" width="100%">
        <Box maxWidth="50%" flexShrink="0">
          <Typography
            variant={isPlugin ? 'caption' : 'body3'}
            color="text.light.tertirary"
          >
            <EllipsisText wordBreak="break-all" rows={1}>
              {name}
            </EllipsisText>
          </Typography>
        </Box>
        <Typography
          variant={isPlugin ? 'caption' : 'body3'}
          color="text.light.tertirary"
        >
          •
        </Typography>
        <Box>
          <Typography
            variant={isPlugin ? 'caption' : 'body3'}
            color="text.light.tertirary"
          >
            <EllipsisText wordBreak="break-all" rows={1}>
              {action}
            </EllipsisText>
          </Typography>
        </Box>
      </Box>
      <Box width="fit-content">
        <Typography
          noWrap
          variant={isPlugin ? 'caption' : 'body3'}
          color="text.light.tertirary"
        >
          {createdAt}
        </Typography>
      </Box>
    </Box>
  );
};
